var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Layout',[_c('div',{attrs:{"id":"app-loader"}},[_c('div',{staticClass:"dots",style:(_vm.wrapperStyle)},_vm._l((5),function(i){return _c('span',{key:i,staticClass:"dot",style:(_vm.dotStyle(i))})}),0)])])
}
var staticRenderFns = []

export { render, staticRenderFns }